import Loader from "./Loader/LoaderComponent"
export default function LoadingScreen(){
  return(
    <div className="absolute inset-0 flex justify-center items-center bg-gray-500">
      <Loader/>
    </div>
  )
}
